import type { FlowContext } from '@wix/funnel-builder-lizard'
import { tryCatchSync } from '@wix/funnel-utils'
import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

export const useFlowContext = (): [FlowContext | undefined, (flowContext: FlowContext) => void] => {
  const [searchParams, setSearchParams] = useSearchParams()
  const flowContextSearchParam = searchParams.get('flowContext') ?? ''

  const flowContext = useMemo(() => {
    const [, flowContext] = tryCatchSync(() => JSON.parse(decodeURIComponent(window.atob(flowContextSearchParam))))
    return flowContext
  }, [flowContextSearchParam])

  const setFlowContext = useCallback(
    (flowContext: FlowContext) => {
      setSearchParams(prevSearchParams => {
        prevSearchParams.delete('flowContext')
        prevSearchParams.append('flowContext', window.btoa(encodeURIComponent(JSON.stringify(flowContext))))
        return prevSearchParams
      })
    },
    [setSearchParams],
  )

  return [flowContext, setFlowContext]
}
